import { useState } from 'react';
import { CourseMaterialTypeClient, CourseMaterialTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCourseMaterialTypeApi = () => {
    const apiClient = new CourseMaterialTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CourseMaterialTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCourseMaterialType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CourseMaterialType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CourseMaterialTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCourseMaterialType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CourseMaterialType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCourseMaterialTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CourseMaterialType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCourseMaterialTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CourseMaterialTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCourseMaterialType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CourseMaterialType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};